import React from "react";
import { Link } from "react-router-dom";
import Logo from "../../assets/images/logoo.svg";

const Footer = () => {
    return (
        <>
            {/* Divider */}
            <div className="h-[2px] bg-[#00B3A4]" />

            <footer className="bg-white py-16">
                <div className="container mx-auto px-6">
                    <div className="grid grid-cols-1 md:grid-cols-4 gap-10">

                        {/* Brand */}
                        <div>
                            <div className="flex items-center gap-3 mb-4">
                                <img src={Logo} alt="Invexflow" className="w-8 h-8 rounded-md" />
                                <span className="font-semibold text-[#0F172A]">
                                    Invexflow
                                </span>
                            </div>

                            <p className="text-sm text-[#64748B] mb-4">
                                Invoice discounting for modern businesses.
                            </p>

                            <p className="text-sm text-[#94A3B8]">
                                © 2025 Invexflow Ltd.
                            </p>
                        </div>

                        {/* Product */}
                        <FooterColumn
                            title="Product"
                            links={[
                                { label: "How it works", to: "/how-it-works" },
                                { label: "Solutions", to: "/solutions" },
                                { label: "Security", to: "#" },
                            ]}
                        />

                        {/* Company */}
                        <FooterColumn
                            title="Company"
                            links={[
                                { label: "About", to: "/about" },
                                { label: "Contact", to: "/contact" },
                                { label: "Careers", to: "#" },
                            ]}
                        />

                        {/* Legal */}
                        <FooterColumn
                            title="Legal"
                            links={[
                                { label: "Privacy Policy", to: "/privacy-policy" },
                                { label: "Terms & Conditions", to: "/terms-conditions" },
                                { label: "Cookies", to: "#" },
                            ]}
                        />

                    </div>
                </div>
            </footer>
        </>
    );
};

const FooterColumn = ({ title, links }) => (
    <div>
        <h4 className="text-sm font-semibold text-[#0F172A] mb-4">
            {title}
        </h4>
        <ul className="space-y-2 text-sm text-[#64748B]">
            {links.map((link) => (
                <li key={link.label}>
                    <Link to={link.to} className="hover:text-[#0F766E] transition">
                        {link.label}
                    </Link>
                </li>
            ))}
        </ul>
    </div>
);

export default Footer;